import Colors from './Colors';

const Theme = {
  legal: {
    head: {
      light: Colors.lightGray,
      dark: Colors.darkBlueGray,
      dracula: Colors.lightGray,
      bright: Colors.darkBlueGray,
    },
    banner: Colors.white,
    bg: Colors.white,
  },
  botBar: {
    bg: {
      light: Colors.lightGray,
      dark: Colors.darkBlueGray,
      dracula: Colors.lightGray,
      bright: Colors.darkBlueGray,
    },
    link: {
      light: Colors.lightGray,
      dark: Colors.darkBlueGray,
      dracula: Colors.lightGray,
      bright: Colors.darkBlueGray,
    },
  },
};

export default Theme;



// WEBPACK FOOTER //
// ./src/constants/Theme.tsx